import styled from 'styled-components';
import { Font } from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  src: 'http://fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf',
});

type ValuationContainerProps = {
  isexcluded: string;
};

export const ValuationContainer = styled.div<ValuationContainerProps>`
  width: ${(props) => (props.isexcluded === 'true' ? `100%` : `50%`)};
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 60% 40%;
  gap: 32px;
`;

export const ValuationContainerExclude = styled.div`
  width: 100%;
  max-height: 100px;
  border: 1px solid red;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
`;

export const ValuationTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 17px;
  color: #747d93;
  font-weight: 500;
`;

export const ValuationPricesContainer = styled.div<{
  pricesBreakdown?: boolean;
}>`
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-bottom: ${(props) =>
    props.pricesBreakdown ? `1px solid #b6bbc6` : `none`};
`;

/** Row that contains main price block + separator (price by status). Yield goes below in its own full-width row. */
export const ValuationPricesTopRow = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  column-gap: 8px;
`;

export const ValuationPricesMain = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const ValuationBreakdownDotMax = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #cd4c41;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ValuationBreakdownDotMedium = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #299b9a;
`;

export const ValuationBreakdownDotMin = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #f2bf12;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ValuationPricesBreakdown = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  column-gap: 8px;
`;

export const ValuationPricesBreakdownPartMin = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  column-gap: 10px;
  background-color: #fef9e7;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 2px;
`;

export const ValuationPricesBreakdownPartMax = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  column-gap: 10px;
  background-color: #f7e2d7;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 12px;
  border-radius: 2px;
`;

export const ValuationPricesBreakdownPartLabel = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ValuationMainPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  column-gap: 5px;
  border-radius: 15px;
`;

type ValuationMainPriceProps = {
  operation: number;
  pricesBreakdown?: boolean;
};

export const ValuationMainPrice = styled.span<ValuationMainPriceProps>`
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 500;
  color: ${(props) => (props.operation === 1 ? `#2C003E` : `#B56820`)};
`;

export const ValuationMainPriceSufix = styled.span<ValuationMainPriceProps>`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: ${(props) => (props.operation === 1 ? `#2C003E` : `#B56820`)};
`;

export const ValuationSqmPrice = styled.span`
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #212632;
`;

export const ValuationMarketSituationContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 7px;
  box-sizing: border-box;
`;

export const ValuationMarketSituationTitle = styled.div`
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
`;

export const ValuationMarketSituationDataBlocks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  box-sizing: border-box;
`;

export const ValuationMarketSituationDataBlock = styled.div<ValuationMainPriceProps>`
  width: 100%;
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #eff7fb;
  border-radius: 2px;
  text-align: center;
  color: #023e8a;
  box-sizing: border-box;
`;

export const ValuationMarketSituationDataBlockLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
`;

export const ValuationMarketSituationDataBlockValueContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 3px;
`;

export const ValuationMarketSituationDataBlockValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
`;

export const ValuationMarketSituationDataBlockValueSufix = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
`;

/** Blue container for yield value (same style as annual profitability blocks). Full width below the price row. */
export const ValuationYieldContainer = styled.div`
  width: 100%;
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #eff7fb;
  border-radius: 2px;
  text-align: center;
  color: #023e8a;
  box-sizing: border-box;
  margin-top: 12px;
  flex-shrink: 0;
`;

export const ValuationYieldLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
`;

export const ValuationYieldValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 700;
`;

export const ValuationSeparator = styled.div<{ show?: boolean }>`
  flex: 0 0 32%;
  min-width: 0;
  display: flex;
  padding: 8px 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ show }) => (show ? '#eff2f7' : '#ffffff')};
  gap: 10px;
  border-radius: 2px;
`;

export const ValuationStatusPrice = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  row-gap: 3px;
`;

export const ValuationStatusPriceLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-align: start;
  color: #747d93;
`;

type ValuationStatusPriceValueProps = {
  isLargeValue?: boolean;
};

export const ValuationStatusPriceValue = styled.span<ValuationStatusPriceValueProps>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(props) => (props.isLargeValue ? '12px' : '14px')};
  font-weight: 700;
  color: #747d93;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
  line-height: 1.2;
`;

export const Separator = styled.span`
  width: 100%;
  height: 1px;
  background-color: #b6bbc6;
`;

export const ValuationMarketSituationContent = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

type FeatureCellProps = {
  backgroundcolor: string;
  color: string;
};

export const FeatureCell = styled.div<FeatureCellProps>`
  width: fit-content;
  background-color: ${(props) => props.backgroundcolor};
  padding: 2px 8px;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  column-gap: 5px;
  text-align: center;
  border-radius: 20px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  height: 25px;

  @media print {
    background-color: ${(props) => props.backgroundcolor} !important;
    color: ${(props) => props.color} !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;
